import * as API from "../apis/autographApi";
import { observable, action } from "mobx";

export default class AutographStore {
  @observable initInfo = [];
  @observable isAutoResizeSignImage = true;
  @observable recordId = "0";
  @observable visible = true;

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  };
  @action
  getAutographInfo = params => {
    return new Promise(resolve => {
      API.getAutographInfo(params).then(res => {
        this.initInfo = res;
        resolve(res);
      });
    });
  };

  @action
  saveAutograph = needCheck => {
    if (!window.document.Consult) {
      return -3;
    }
    if (needCheck) {
      if (
        window.document.Consult.DocEmpty &&
        window.document.Consult.OpinionText == ""
      ) {
        return -2;
      }
    }
    //TODO save
    let record = "";
    const timestamp = Date.parse(new Date()) / 1000;
    if (window.document.Consult.Modify) {
      // let saveFlag = window.document.Consult.SaveSignature();
      let saveFlag = this.isAutoResizeSignImage
        ? window.document.Consult.SaveAsGifEx(
            timestamp + ".gif",
            "All",
            "Remote"
          )
        : window.document.Consult.SaveSignature();
      if (!saveFlag) {
        return -1;
      }
      record = window.document.Consult.WebGetMsgByName("RECORDID");
      if (parseInt(record) > 0 && this.isAutoResizeSignImage) {
        window.document.Consult.WebSetMsgByName("TEMPCALL", "1");
        window.document.Consult.WebSetMsgByName("TEMPID", record);
        saveFlag = window.document.Consult.SaveSignature();
      }
    } else {
      return parseInt(this.recordId, 10) > 0 ? this.recordId : true;
    }
    return record;
  };
}



// WEBPACK FOOTER //
// ./comMobx/wea-autograph/stores/autographStore.js